import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <Section background="paper" labelledBy="bonuses-heading" data-id="element-33" data-mp="plsky6ka14aa">
      <div className="text-center" data-id="element-34" data-mp="aua8ujujftw7">
        <p className="inline-flex items-center gap-2 rounded-full bg-sage-soft px-4 py-2 font-sans text-[11px] font-semibold uppercase leading-none tracking-[0.14em] text-sage" data-id="element-35" data-mp="at8uo6i86ra9">
          <GiftIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-36" data-mp="1t3pm30i84z9" />5 field bonuses
          included free
        </p>

        <h2 id="bonuses-heading" className="mx-auto mt-6 max-w-2xl font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[40px]" data-id="element-37" data-mp="3o1v5efaefsp5">
          Total bonus value: $60 → free with your Screen &amp; Adapt™
        </h2>
      </div>

      <ul className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-38" data-mp="1mb1if6y30974">
        {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col overflow-hidden rounded-2xl border border-sage/15 bg-white shadow-card" data-id="element-39" data-mp="1r6z1hl0qbtnl">
            <div className="aspect-square w-full overflow-hidden bg-paper" data-id="element-40" data-mp="3df3bbshuznll">
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-full w-full object-cover" loading="lazy" data-id="element-41" data-mp="3r5gi3rj0kw9c" />
            </div>

            <div className="flex flex-1 flex-col p-6" data-id="element-42" data-mp="2zfu7lsaualyi">
              <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-brass" data-id="element-43" data-mp="2uh0va37ah0zx">
                Bonus {bonus.number}
              </p>
              <h3 className="mt-3 font-serif text-xl font-semibold leading-snug text-ink" data-id="element-44" data-mp="38dw2dq3zcidc">
                {bonus.title}
              </h3>
              <p className="mt-3 font-sans text-[14px] font-semibold" data-id="element-45" data-mp="np8denoybnmf">
                <span className="text-ink-muted line-through" data-id="element-46" data-mp="iqyfi5bue8x4">{bonus.price}</span>
                <span className="ml-2 text-sage" data-id="element-47" data-mp="it14cm19dw09">→ Free</span>
              </p>
              <p className="mt-4 font-sans text-[15px] leading-[1.6] text-ink-soft" data-id="element-48" data-mp="3ciekez4q7mwz">{bonus.body}</p>
            </div>
          </li>)}
      </ul>
    </Section>;
}